cv.PublicDonorsRowView = Marionette.LayoutView.extend({
  tagName: 'div',
  className: 'donor',
  template: cv.Templates['public/donors/donors_row'],

  events : {
  },

  templateHelpers: function(){
    return {
      display_name : this.model.get('display_name'),
      amount : this.model.get('amount'),
      comment : this.model.get('comment'),
      currency_code : this.model.get('campaign.currency_code')
    };
  },

  initialize: function(options){
    console.log('PublicDonorsRowView initialized');
  },

  onShow: function(){
  }
});
